export enum CacheId {
  // HISTORY
  History = "imax-history",
  // PLANS
  ActivePlan = "imax-active-plan",
  StandbyPlan = "imax-standby-plan",
  ActivePlanEdits = "imax-active-plan-edits",
  StandbyPlanEdits = "imax-standby-plan-edits",
  // SETTINGS
  Settings = "imax-settings",
  // PILOT DATA
  PilotData = "imax-pilot-data",
  // HI RECORDS
  Hi1 = "imax-hi1",
  Hi2 = "imax-hi2",
  // VERSIONS
  Versions = "imax-versions",
  // KNOWN ISSUES
  KnownIssues = "imax-known-issues",
  // FAQs
  Faqs = "imax-faqs",
}
